// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mNSF","largestCol":"styles_largestCol__V98da","smallestCol":"styles_smallestCol__2v4Ir"};